import React, {useEffect, useState} from "react";
import axios from "../utils/apiClient";
import {Badge, Button, Spinner} from "react-bootstrap";
import ErrorToast from "../views/common/ErrorToast";

const componentName = "FileUpload";

const isEmpty = require("is-empty");

const FileUpload = ({
  disabled,
  accept,
  multiple = true,
  topComponent = "",
  onChange,
  saveToBackend = true,
  clearStateProp,
  //cancelUploads
  btnClass,
  showIcon = true,
  label = "Upload File(s)",
  uploadedFiles = [],
  showFileList = true,
  onUploadingChange
}) => {
  const [fileList, setFileList] = useState([]);
  const [clearState, setClearState] = useState(0);
  const [showProgress, setShowProgress] = useState(false);
  const [errors, setErrors] = useState(null);
  const [inputKey, setInputKey] = useState("inputKey");

  useEffect(() => {
    if (uploadedFiles && uploadedFiles.length > 0) {
      const files = uploadedFiles.map(file => file.fileMetadata)
      setFileList(files)
    }
  }, [uploadedFiles])

  const checkForDuplicateFiles = (fileList, newFileList) => {
    let fileNamesExisting=[];
    let fileNamesNew;
    fileList.forEach((file) => fileNamesExisting.push(file?.fileName));
    fileNamesNew = newFileList[0]?.fileName;
    return fileNamesExisting.includes(fileNamesNew);
  };

  const handleChange = (newFileList, appendFileList = true) => {
    let mergedFileList;
   if(!appendFileList) {
      mergedFileList = newFileList;
    }
    else if((newFileList.length <= 1 && fileList.length === 0) || !checkForDuplicateFiles([...fileList], [...newFileList])){
      mergedFileList = appendFileList ? [...fileList, ...newFileList] : newFileList;
    }
    else {
      mergedFileList = [...fileList];
    }
    setFileList(mergedFileList);
    onChange && onChange(mergedFileList);
  };

  const uploadFiles = (filesObj) => {
    setErrors(null)
    axios
      .post(
        `${process.env.REACT_APP_REST_API_BASE_URL}/v1/file-upload/fileUpload/multiple`,
        filesObj,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        const error = res?.data?.filter(e=> e.error && e.errorMessage)?.[0]?.errorMessage
        if(error){
          setErrors(error);
          setInputKey(`inputKey-${Math.random()}`)
        }
        else{
          handleChange(res.data);
        }
        setShowProgress(false);
        onUploadingChange && onUploadingChange(false);
      })
      .catch((err) => {
        //formatErrorMessage(err);
        setShowProgress(false);
        onUploadingChange && onUploadingChange(false);
      });
  };

  const deleteFileUpload = (id) => {
    if (!id) {
      return;
    }

    axios
      .delete(
        `${
          process.env.REACT_APP_REST_API_BASE_URL
        }/v1/file-upload/file?id=${encodeURIComponent(id)}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {})
      .catch((err) => {
        //formatErrorMessage(err);
      });
  };

  const handleFileUpload = (e) => {
    setShowProgress(true);
    onUploadingChange && onUploadingChange(true);
    let filesObj = {};
    const fileCount = e.target.files.length;
    if (fileCount === 0) {
      setShowProgress(false);
      onUploadingChange && onUploadingChange(false);
      return;
    }
    for (let file of e.target.files) {
      const fileReader = new FileReader();
      fileReader.filename = file.name;
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = function (readerEvt) {
        if (
          readerEvt &&
          readerEvt.currentTarget.result &&
          !isEmpty(readerEvt.currentTarget.result)
        ) {
          filesObj[readerEvt.currentTarget.filename] = Array.from(
            new Uint8Array(readerEvt.currentTarget.result)
          );
        }
      };
    }
    e.target.value='';
    (function wait() {
      if (Object.keys(filesObj).length < fileCount) {
        setTimeout(wait, 2000);
      } else {
        if (saveToBackend) {
          uploadFiles(filesObj);
        } else {
          handleChange(filesObj);
          setShowProgress(false);
          onUploadingChange && onUploadingChange(false);
        }
      }
    })();
  };
  
  useEffect(() => {
    if (clearState !== clearStateProp) {
      setFileList([]);
      setClearState(clearStateProp);
    }
  }, [clearState, clearStateProp]);

  return (
    <div disabled={disabled} className="d-inline-block" id="FileUploadButton">
      {topComponent}
      <label id={`${componentName}-FileUpload`} className={`btn btn-primary me-0 ${btnClass ? btnClass : ''} ${disabled ? 'opacity-50' : ''}`}>
        <input type="file" multiple={multiple} onChange={handleFileUpload} key={inputKey} disabled={disabled} />
        {showIcon && <i className="fa fa-cloud-upload me-2"></i>}
        {label}
      </label>
      {showProgress && (
        <Badge pill bg="light" text="dark" className="border align-items-center position-absolute top-50 start-50 zindex-1040">
          <Spinner className="me-2" as="span" animation="border" size="sm" aria-hidden="true" /> <output>Loading...</output>
        </Badge>
      )}
      <div className="d-block mt-2">
        {(fileList && showFileList) &&
          fileList.map((fl, index) => (
            <div key={index}>
              <Button variant="link" className="p-0 me-3"
                onClick={(e) => {
                  const newFileList = [...fileList];
                  const [fileUploadToDelete] = newFileList.splice(index, 1);
                  handleChange(newFileList, false);
                  if (saveToBackend) {
                    deleteFileUpload(fileUploadToDelete?.fileId || fileUploadToDelete?.id);
                  }
                }}
                aria-label="Delete file"
              >
                <i className="fa-solid fa-xmark"></i>
              </Button>
              <span>{fl.fileName || fl.name}</span>
            </div>
          ))}
      </div>
      {errors?.length > 0 &&
        <ErrorToast
          className="float-end"
          errorParam={errors}
          closeToast ={()=>setErrors(null)}
        />
      }
    </div>
  );
};

export { FileUpload };
